import { useQuery } from 'react-query';
import { useUnityBuildStore } from '../stores/store';
import { ChangeOrderService as cos } from '../api/ChangeOrderService';
import { useStore } from 'zustand';

export function useFetchChangeOrders(estimateId?: string) {
  const { selectedContract } = useStore(useUnityBuildStore);

  const { data, error, isLoading, refetch } = useQuery(
    ['changeOrders', selectedContract?.contractid, estimateId],
    async () => {
      if (selectedContract?.contractid && estimateId) {
        const response = await cos.getChangeOrders(selectedContract.contractid, estimateId);
        return response.changeordersList;
      }
      throw new Error('No valid contract ID and estimate ID available for fetching change orders');
    },
    {
      enabled: !!(selectedContract?.contractid && estimateId),
    }
  );
  return { data, error, isLoading, refetch };
}
